
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { addInquirySheet } from "@/api/inquiry";
import { COMPANY_LIST } from "@/constant";
import { changeUpload, uploadInfoFile, deleteShippingMarks, deleteInfo } from "@/api/proforma";
import {
  searchCustomer
} from "@/api/customer";
import { getAppendix } from "@/api/proforma";
import { doDownload,doDownloadPDF } from "@/utils/oss-download";

@Component({
  name: "file-management"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "查看回执" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {} | any;

  @Watch("show", { immediate: true })
  private async watchData() {
    if (this.show) {
      this.getAppendix();
    }
  }

  private form = {
    customerId: null,
    company: null
  };
  public info = {} as any;
  public infoFields = [
    {
      label: "采购订单号",
      key: "poCode"
    },
    {
      label: "供应商简称",
      key: "supplierAbbreviation"
    },
    {
      label: "采购员",
      key: "purchase"
    },
    {
      label: "销售员",
      key: "seller"
    }
  ] as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "文件名",
      prop: "description",
      key: "description",
      show: true,
      disabled: false
    },
    {
      label: "上传时间",
      prop: "uploadTime",
      key: "uploadTime",
      show: true,
      disabled: false
    },
    {
      label: "上传用户",
      prop: "uploader",
      key: "uploader",
      show: true,
      disabled: false
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "预览", code: '', click: "handleDownload",key:'fileType',value: 'OTHER' },
        { name: "预览", code: '', click: "handleDownload",key:'fileType',value: 'IMAGE',type: 'popoverImage',image: 'ossUrl' },
        { name: "删除", code: '', click: "handleDelete" },
        { name: "替换", code: '', click: "handleUpdate", type: "upload"},
      ],
      show: true,
      disabled: false,
      width: 100
    }
  ] as any;

  private close() {
    this.$emit("update:show", false);
    this.$emit("close-and-refresh-list");
  }

  private open() {
    this.$emit("update:show", true);
  }

  // 获取附件
  private async getAppendix() {
    this.info = await getAppendix(this.selectedItem.id, {
      receipt: true
    });
  }
  private handleDownload(scope: any) {
    console.log(scope.row);
    if(scope.row.fileType === 'IMAGE') {

    } else {
      window.open(scope.row.ossUrl);
    }
  }
  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            this.addInquirySheet();
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }


  private handleChange(scope: any) {
    console.log(scope.row);
  }

  // 新建询价单
  private async addInquirySheet() {
    const { customerId, company } = this.form;
    let params = {
      customerId,
      company
    };
    try {
      await addInquirySheet(params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }

  private async allUpLoad(file) { // 批量上传
    let formData = new FormData();
    formData.append("poId", this.selectedItem.id);
    formData.append("receipt", "true");
    formData.append("files", file.file);
    await uploadInfoFile(formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000
    });
    this.getAppendix()
  }

  private allDelete() { // 批量删除
    if(this.selectedRows.length < 1) {
      this.$notify({
        title: "提示",
        message: "请选择需要删除的数据",
        type: "error",
        duration: 2000
      });
      return;
    } else {
      const ids = this.selectedRows.map(item => item.id);
      const params = ids.map((id) => `ids=${id}`).join("&");
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await deleteInfo(params);
          this.$notify({
            title: "成功",
            message: "删除成功",
            type: "success",
            duration: 2000
          });
          (this.$refs.table as any).$refs.table.clearSelection();
          this.getAppendix();
        })
        .catch((err) => {
          console.error(err);
        });
      this.getAppendix()
    }
    
  }

  private selectedRows: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.selectedRows = rows;
  }

  private handleDelete(row) { // 行内删除
    const ids = [row.row.id]
    const params = ids.map((id) => `ids=${id}`).join("&");
    this.$confirm("确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        await deleteInfo(params);
        this.$notify({
          title: "成功",
          message: "删除成功",
          type: "success",
          duration: 2000
        });
        this.getAppendix();
      })
      .catch((err) => {
        console.error(err);
      });
    this.getAppendix()
  }

  private async handleUpdate(val) {
    const { file, item } = val;
    let formData = new FormData();
    formData.append("id", item.id);
    formData.append("receipt", "true");
    formData.append("file", file.file);
    await changeUpload(item.id, formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000
    });
    this.getAppendix();
  }


}
